export default {
	API_ENDPOINT: `https://damp-anchorage-91782.herokuapp.com/api`,
	// API_ENDPOINT: `http://localhost:3000/api`,
	TOKEN_KEY: `homebl-token-key`,
}
